import { EnvironmentProviders } from '@angular/core';
import { Route, RouterFeatures, provideRouter, withPreloading, withRouterConfig, withViewTransitions } from '@angular/router';

import { SpeculativeLinkPreloader } from '@frontend/vanilla/features/speculative-link';

import { onViewTransitionCreated } from './view-transition/view-transition';

export function provideRouterOverride(routes: Route[], viewTransitionsEnabled: boolean): EnvironmentProviders {
    const features: RouterFeatures[] = [withPreloading(SpeculativeLinkPreloader), withRouterConfig({ urlUpdateStrategy: 'eager' })];

    if (viewTransitionsEnabled) {
        features.push(withViewTransitions({ skipInitialTransition: true, onViewTransitionCreated }));
    }

    return provideRouter(routes, ...features);
}
